import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ContactAddressDto, ContactDto } from "../models"
import { InitialState } from "./types"

const initialAddressState: ContactAddressDto ={
    id: "",
    addressType: "",
    city: "",
    country: "",
    countryCode: "",
    firstName: "",
    isDefault: true,
    lastName: "",
    postalCode: "",
    state: "",
    stateCode: "",
    street: "",
    street2: "",
}

const initialOrganizationState = {
    attributes: {
        name: "",
        address:{
            id: "",
            addressType: "",
            city: "",
            country: "",
            countryCode: "",
            firstName: "",
            isDefault: true,
            lastName: "",
            postalCode: "",
            state: "",
            stateCode: "",
            street: "",
            street2: "",
        },
    }
}

const initialState: InitialState = {
    address: initialAddressState,
    organizationName: "",
    organizationId: "",
    phoneNumbers:[],
    email: "",
    firstName: "",
    lastName: "",
    notes: "",
    paymentTermId: "",
    taxId: "",
    taxNumber: "",
    title: "",
    language: "",
    labelIds: [],
    deletedAt:"",
    labels: [],
    persons: [] ,//if contact is organization  (split person / org)
    organization: initialOrganizationState,
    primaryContactId: "",
    name: "",
    isError: false,
    fetchSuccess: false,
    errorMessage: "",
    id: "",
    createdAt: "",
    primaryContactName:"",
    duplicatedContactsByEmail: [],
    duplicatedContactsByPhoneNumber:[],
    creditLimit: 0,
    externalLinks: [],
    customerAccountIds : []
}



const contactReducer = createSlice({
    name: "contact_reducer",
    initialState,
    reducers: {
        setContact: (state, action: PayloadAction<InitialState>) => {
            state=action.payload
        },
        setDuplicatedContactsByEmail: (state, action: PayloadAction<ContactDto[]>) => {
            state.duplicatedContactsByEmail=action.payload
        },
        setDuplicatedContactsByPhoneNumber: (state, action: PayloadAction<ContactDto[]>) => {
            state.duplicatedContactsByPhoneNumber=action.payload
        },
        deleteFailed: (state, action: PayloadAction<string>) => {
            state.errorMessage=action.payload
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchSupplier: (state, action: PayloadAction<string>) => {
            state.isLoading = true
        },
        fetchContactFormSuccess: (state, action: PayloadAction<ContactDto>) => {
            const contactDto = action.payload
            const newState={
                ...contactDto.attributes,
                id:contactDto.id,
                duplicatedContactsByEmail: state.duplicatedContactsByEmail,
                duplicatedContactsByPhoneNumber: state.duplicatedContactsByPhoneNumber,
                isLoading: false,
            }
            return newState
        },
        clear: () => {
            return initialState
        }
    },
})

export const {
    setContact,
    setDuplicatedContactsByEmail,
    setDuplicatedContactsByPhoneNumber,
    deleteFailed,
    fetchSupplier,
    fetchContactFormSuccess,
    clear,
} = contactReducer.actions
export default contactReducer.reducer


// WEBPACK FOOTER //
// ./src/state/contact/reducers/reducer.ts